import Settings from './Settings'

export default [
    {
        path: '/settings',
        component: Settings
    }
]
